import { IndicatorDetailFields } from 'common/enums';
import { FieldError } from 'common/models';
import { ErrorData } from 'common/models/data/error.model';

export const addValidationError = (errors: Array<FieldError>, field: string, message: string) => {
    if (!errors.some((item: FieldError) => item.field === field && item.message === message)) {
        const updatedErrors = [...errors];
        updatedErrors.push({
            field,
            message
        });
        return updatedErrors;
    }
    return errors;
};

export const removeValidationError = (
    errors: Array<FieldError>,
    field: string,
    message?: string
) => {
    let updatedErrors = [...errors];
    if (message) {
        updatedErrors = errors.filter(
            (item: FieldError) => field !== item.field && message !== item.message
        );
    } else {
        updatedErrors = errors.filter((item: FieldError) => field !== item.field);
    }
    return updatedErrors;
};

export const mapFieldErrors = (fieldErrors: Array<FieldError>) =>
    fieldErrors.map((item: FieldError) => ({
        ColName: item.field,
        Rule: item.message
    }));

/**
 * To handle cases when error field is different from data field
 */

export const mapToFieldErrors = (errorData: Array<ErrorData>) =>
    errorData.map((item: ErrorData) => {
        let columnName = item.columnName;
        if (columnName === 'IndicatorName') columnName = IndicatorDetailFields.Name;
        if (columnName === 'Reference') columnName = IndicatorDetailFields.Reference;
        if (columnName === 'SourceId') columnName = IndicatorDetailFields.SourceId;
        if (columnName === 'Description') columnName = IndicatorDetailFields.Description;
        if (columnName === 'FrequencyId') columnName = IndicatorDetailFields.FrequencyTypeId;
        return {
            field: columnName,
            message: item.ruleName
        };
    });
